"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuDesktop = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// todo: remove when ie11 becomes unsupported
var IE11StyledMenuDesktop = _styledComponents.default.div.withConfig({
  displayName: "AuthorizedMenuDesktopstyles__IE11StyledMenuDesktop",
  componentId: "zr5gju-0"
})(["display:-ms-grid;-ms-grid-columns:auto 1fr auto;-ms-grid-rows:1fr;.c-menu-desktop-logo{-ms-grid-column:1;}.c-menu-desktop-title{-ms-grid-column:2;}.c-menu-desktop-menu-items{-ms-grid-column:3;}"]);

var StyledMenuDesktop = (0, _styledComponents.default)(IE11StyledMenuDesktop).withConfig({
  displayName: "AuthorizedMenuDesktopstyles__StyledMenuDesktop",
  componentId: "zr5gju-1"
})(["height:", ";width:100%;z-index:", ";justify-content:center;.c-menu-desktop-logo{align-items:center;align-self:center;display:flex;padding-left:", ";}.c-menu-desktop-title{align-items:center;align-self:center;display:flex;justify-content:center;}.c-title-text{font-weight:", ";}.c-menu-desktop-items{align-items:center;align-self:center;display:flex;justify-content:flex-end;justify-self:right;}@supports (display:grid){&{display:none;grid-template-areas:\"desktopLogo desktopTitle desktopItems\";grid-template-columns:min-content 1fr min-content;}@media only screen and (min-width:", "){display:grid;}.c-menu-desktop-logo{grid-area:desktopLogo;}.c-menu-desktop-menu-title{grid-area:desktopTitle;}.c-menu-desktop-items{grid-area:desktopItems;}}"], function (props) {
  return props.theme.authorizedMenuHeight;
}, function (props) {
  return props.theme.menu;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.maxWidth;
});
exports.StyledMenuDesktop = StyledMenuDesktop;